export default __webpack_public_path__ + "static/media/bn-key.ef3d784e.png";